import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'claims.popUp.title',
        defaultMessage: 'PopUp message'
    },
    NO_MESSAGE: {
        id: 'claims.popUp.noMessage',
        defaultMessage: 'No message'
    },
    CONFIRMATION_MESSAGE: {
        id: 'claims.popUp.confirmationMessage',
        defaultMessage: 'I RECOGNIZED TO HAVE KNOWN THE MESSAGE ABOVE'
    },
});

export default messages;
